// extracted by mini-css-extract-plugin
module.exports = {"section":"Card-section-2tedu"};